<template>
  <v-app v-cloak toolbar footer class="dovetail-app">
    <v-slide-y-transition mode="out-in">
      <appbar>
        <slot name="appbar"></slot>
      </appbar>
    </v-slide-y-transition>

    <!-- Main Content -->

    <v-content>
      <!-- Preloader -->
      <!-- <preloader></preloader> -->
      <!-- Preloader -->

      <!-- Main -->
      <v-slide-y-transition mode="out-in">
        <router-view></router-view>
      </v-slide-y-transition>
      <!-- Main -->
    </v-content>
    <!-- Main Content -->
  </v-app>
</template>

<script>
export default {
  name: 'Auth',
}
</script>
